import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY } from '../lib/company';

export default function Footer() {
  return (
    <footer className="border-t border-gray-200 bg-white mt-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <img
                src="/brand/icon.webp"
                alt="LeadXchange"
                className="w-8 h-8 rounded-sm object-contain"
              />
              <span className="font-heading text-xl font-semibold tracking-tight text-gray-900">
                LeadXchange
              </span>
            </div>
            <p className="text-sm text-gray-600 max-w-sm leading-relaxed">
              Australia's marketplace for qualified business leads.
            </p>
            <p className="text-xs text-gray-500 mt-2 max-w-sm">
              Find leads. Connect with buyers. Grow your business.
            </p>
          </div>

          {/* Product */}
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-gray-500 font-mono font-semibold mb-3">
              Product
            </div>
            <div className="space-y-2">
              <FooterLink to="/marketplace">Marketplace</FooterLink>
              <FooterLink to="/pricing">Pricing</FooterLink>
              <FooterLink to="/register?role=buyer">For Buyers</FooterLink>
              <FooterLink to="/register?role=seller">For Sellers</FooterLink>
            </div>
          </div>

          {/* Trust */}
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-gray-500 font-mono font-semibold mb-3">
              Trust & Legal
            </div>
            <div className="space-y-2">
              <FooterLink to="/legal/terms">Terms of Service</FooterLink>
              <FooterLink to="/legal/privacy">Privacy Policy</FooterLink>
              <FooterLink to="/legal/refund">Refund Policy</FooterLink>
              <FooterLink to="/legal/non-circumvention">Non-Circumvention</FooterLink>
              <FooterLink to="/status">Status</FooterLink>
            </div>
          </div>
        </div>

        {/* Bottom — minimal legal disclosure only */}
        <div className="mt-10 pt-6 border-t border-gray-200">
          <p className="text-xs text-gray-500 leading-relaxed" data-testid="footer-legal-line">
            © 2026 LeadXchange. All rights reserved. Operated by {COMPANY.legalName} (ABN {COMPANY.abn}).
          </p>
        </div>
      </div>
    </footer>
  );
}

const FooterLink = ({ to, children }) => (
  <Link to={to} className="block text-sm text-gray-600 hover:text-gray-900 transition-colors">
    {children}
  </Link>
);
